import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 删除所有同步导入的语言包
// 所有语言包将通过异步方式动态加载

// 初始资源为空，在运行时动态添加
const resources = {};

// 创建一个异步加载语言包的函数
const loadLocale = async (locale: string) => {
  try {
    const localeModule = await import(`./locales/${locale}`);
    return localeModule.default || localeModule;
  } catch (error) {
    console.error(`Failed to load locale ${locale}:`, error);
    // 如果加载失败，则尝试加载英语作为后备
    try {
      const fallbackModule = await import(`./locales/en-US`);
      return fallbackModule.default || fallbackModule;
    } catch (fallbackError) {
      console.error('Failed to load fallback locale en-US:', fallbackError);
      return {};
    }
  }
};

i18n
  .use(LanguageDetector) // 检测用户语言
  .use(initReactI18next) // 初始化 react-i18next
  .init({
    fallbackLng: "en-US", // 默认语言
    supportedLngs: [
      "zh-CN", "zh-TW", "zh-HK", "en-US", "ja-JP", "ko-KR", "th-TH", "vi-VN", 
      "de-DE", "es-ES", "ar-EG", "fr-FR", "pt-PT", "it-IT", "ms-MY", "id-ID", 
      "km-KH", "hi-IN", "ru-RU", "tr-TR", "pl-PL", "fil-PH", "sv-SE", "fi-FI", 
      "cs-CZ", "hu-HU", "zh", "en", "ja", "ko", "th", "vi", "de", "es", "ar", 
      "fr", "pt", "it", "ms", "id", "km", "hi", "ru", "tr", "pl", "fil", "sv", 
      "fi", "cs", "hu"
    ], // 支持的语言
    debug: false, // 开发模式下启用调试
    ignoreJSONStructure: true, // 忽略语言代码结构警告
    interpolation: {
      escapeValue: false, // React 已经处理了 XSS
    },
  }, (err, t) => {
    if (err) {
      console.log('i18n initialization failed:', err);
    } else {
      console.log('Detected language:', i18n.language); // 打印检测到的语言
    }
  });

// 添加一个自定义的加载语言包的方法
i18n.loadLanguage = async (lng: string) => {
  if (!i18n.hasResourceBundle(lng, 'translation')) {
    const translations = await loadLocale(lng);
    i18n.addResourceBundle(lng, 'translation', translations, true, true);
  }
};

// 监听语言改变事件，并异步加载对应的语言包
i18n.on('languageChanged', async (lng) => {
  await i18n.loadLanguage(lng);
});

// 初始化时加载当前语言包
i18n.loadLanguage(i18n.language || 'en-US');

export default i18n;
